"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDIT_PROPOSAL = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.EDIT_PROPOSAL = (0, gql_1.gql)(`
   mutation EditProposal($proposal: EditProposalInput!) {
      editProposal(proposal: $proposal) {
        success
        error
      }
   }
`);
